import { render, staticRenderFns } from "./taptop.vue?vue&type=template&id=519038d2"
import script from "./taptop.vue?vue&type=script&lang=js"
export * from "./taptop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports